const isURL = (input: string): boolean => {
  const pattern = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/;
  return pattern.test(input) ? true : pattern.test(`https://${input}`);
};
const replaceUrl = (url: string) => {
  let value = '';
  if (isURL(url)) {
    value = url.indexOf('://') === -1 ? `https://${url}` : url;
  } else {
    value = url.replace('%s', value);
  }
  return value;
};

const openLinkInBrowser = (e: any, link: string) => {
  if (e) {
    e.preventDefault();
  }
  window.dsDesktop?.shellOpenExternal(link);
};

export { isURL, replaceUrl, openLinkInBrowser };
